<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="2">
                <image-change></image-change>
            </v-col>

            <v-col cols="12" md="10">
                <profile-settings></profile-settings>

                <password-change></password-change>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ProfileSettings from '@/components/dashboard/settings/ProfileSettings'
import PasswordChange from '@/components/dashboard/settings/PasswordChange'
import ImageChange from '@/components/dashboard/settings/ImageChange'

export default {
    components: {
        ProfileSettings,
        PasswordChange,
        ImageChange,
    },
}
</script>
